import { parseFieldsConfiguration } from '../dynamicFields/helpers'

import { Node, Replacer, Topic } from './interfaces'

export const parseNode = (node: Node): Topic => {
  return {
    id: `topic-${node.nodeId}`,
    type: 'topic',
    category: 'Topic',
    name: node.displayName,
    isConstant: node.isConstant,
    original: node,
  }
}

export const parseReplacer = (replacer: Replacer): Topic => {
  return {
    id: `replacer-${replacer.replacerId}`,
    type: 'replacer',
    category: replacer.displayName || replacer.replacer,
    original: replacer,
    name: replacer.value,
    isConstant: replacer.isConstant,
    configuration: parseFieldsConfiguration(
      replacer.replacerDefinition.form_definition
    ),
  }
}
